import { getInfoModulePath } from '../app-routing-paths';

export const END_USER_AGREEMENT_PATH = 'end-user-agreement';
export const PRIVACY_PATH = 'privacy';
export const FEEDBACK_PATH = 'feedback';
export const ACCESSIBILITY_SETTINGS_PATH = 'accessibility';

export function getEndUserAgreementPath() {
    return getSubPath(END_USER_AGREEMENT_PATH);
}

export function getPrivacyPath() {
    return getSubPath(PRIVACY_PATH);
}

export function getFeedbackPath() {
    return getSubPath(FEEDBACK_PATH);
}

export function getAccessibilitySettingsPath() {
    return getSubPath(ACCESSIBILITY_SETTINGS_PATH);
}

function getSubPath(path: string) {
    return `${getInfoModulePath()}/${path}`;
}
